<template>
<div class="chapter">
<div class="inner_page">
<p class="fm sgc-1">CONTENTS</p>
<p class="toc1"><a href="#/Text/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/introduction">Introduction</a></p>
<p class="toc1"><a href="#/Text/chapter1">1. All Roads Lead to Whitey</a></p>
<p class="toc"><span href="#/Text/chapter2" title="Link target outside of Sample">2. The Men in the Mob</span></p>
<p class="toc"><span href="#/Text/chapter3" title="Link target outside of Sample">3. Hangouts and Hideouts</span></p>
<p class="toc"><span href="#/Text/chapter4" title="Link target outside of Sample">4. Hits and Heists</span></p>
<p class="toc"><span href="#/Text/chapter5" title="Link target outside of Sample">5. Tinsel Townies: Boston Mobsters in the Movies</span></p>
<p class="toc1"><span href="#/Text/afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><span href="#/Text/sources" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/Text/abouttheauthors" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?552ad89c